import ASCIIFolder from 'fold-to-ascii';

const DEFAULT_REPLACEMENT = '_';

/**
 * Sanitize strings by converting alphabetic, numeric, and symbolic Unicode characters
 * which are not contained in the first 127 ASCII characters (the "Basic Latin" Unicode block)
 * into a ASCII equivalents.
 *
 * @param {string} inputString The string to be sanitized
 * @param {string} replacement The character an unmapped character should be replaced with or null should the original character be retained
 * @return {string} The sanitized string
 */
export const foldToAscii = (
    inputString: string,
    replacement: string = DEFAULT_REPLACEMENT,
): string => ASCIIFolder.foldReplacing(inputString, replacement);
